module.exports = __webpack_public_path__ + "static/media/iphone_logo.f9092202.svg";